import { Divider } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { getImageUrl } from '../../utils/functions/images';
import Instagram from '../../assets/images/landingPageAssets/instagram.svg';
import { useSelector } from 'react-redux';
import { selectFromPage } from '../../../modules/ContactUsForm/slice/contactusSlice';

export default function Footer() {
  const location = useLocation();
  const fromPage = useSelector(selectFromPage);
  const baseLinks = (
    <>
      <Link to='/refund-policy' className='w-full pb-3 text-base font-normal text-center text-gray-600 md:text-end md:pb-0 sm:w-auto'>Refund policy</Link>
      <Link to='/privacy-policy' className='w-full pb-3 text-base font-normal text-center text-gray-600 md:text-end md:pb-0 sm:w-auto'>Privacy policy</Link>
      <Link to='/terms' className='w-full pb-3 text-base font-normal text-center text-gray-600 md:text-end md:pb-0 sm:w-auto'>Terms and conditions</Link>
    </>
  );

  return (
    <footer className='container pb-8'>
      <div className="w-20 pb-4 mx-auto md:w-28 md:pb-8">
        <Divider className="border-t-2 border-gray-400" />
      </div>
      <div className="flex flex-wrap items-center justify-center md:flex-nowrap md:justify-between md:mb-12">
        <img className='pb-10 md:pb-0' alt="peopleCQ" src={getImageUrl('LogoBlack')} />
        <div className='flex flex-wrap justify-center w-full pb-10 md:flex-nowrap gap-x-4 md:pb-0 md:w-fit md:justify-end'>
          {fromPage === '/' || location.pathname === '/' ? (
            baseLinks
          ) : (
            <>
              <Link to='/login' className='w-full pb-3 text-base font-normal text-center text-gray-600 md:text-end md:pb-0 sm:w-auto'>Sign in</Link>
<Link to='/resources' className='w-full pb-3 text-base font-normal text-center text-gray-600 md:text-end md:pb-0 sm:w-auto'>Resources</Link>
                {/* <Link to='/pricing' className='w-full pb-3 text-base font-normal text-center text-gray-600 md:text-end md:pb-0 sm:w-auto'>Pricing</Link> */}
                <Link to='/subscription-plans' className='w-full pb-3 text-base font-normal text-center text-gray-600 md:text-end md:pb-0 sm:w-auto'>Subscription Plans</Link>{/* for demo only */}
              {baseLinks}
            </>
          )}
        </div>
      </div>
      <div className='grid grid-cols-4 gap-4 mx-auto mb-2 w-fit'>
        <a href="https://www.youtube.com/@PeopleCQ-ek8pd" rel='noopener noreferrer' target='_blank'><img src={getImageUrl('youtube')} alt='Youtube' /></a>
        <a href="https://www.facebook.com/profile.php?id=61554153965728" rel='noopener noreferrer' target='_blank'><img src={getImageUrl('facebook')} alt='Facebook' /></a>
        <a href="https://www.instagram.com/peoplecq.ai?igsh=MXAxYmFidnVmb2RxYQ==" rel='noopener noreferrer' target='_blank'><img src={Instagram} alt='Instagram' /></a>
        <a href="https://www.linkedin.com/company/peoplecq/" rel='noopener noreferrer' target='_blank'><img src={getImageUrl('linkedin')} alt='Linkedin' /></a>
      </div>
      <p className='text-base font-normal text-center text-gray-600'>peopleCQ @ {new Date().getFullYear()}. All rights reserved.</p>
    </footer>
  )
}